import type {ReactElement} from 'react';
import styles from './ai-chat-window-inspirations.module.scss';
import {Text, TextSize} from '@Components/text/text';
import {Icon} from '@Components/icon-v2';
import {AiChatInspiration} from './components/ai-chat-inspiration';
import type {AiChatWindowInspirationsProps} from './ai-chat-window-inspirations.types';
import {IconSize, IconType} from '@Components/icon-v2/icon.types';
import {useIsSmallerThanBreakpointWidth} from '@Hooks/useIsSmallerThanBreakpoint';
import {ScreenBreakpoints} from '@Libraries/responsiveness-library';
import {useAiChat} from '@/ai-chat/providers/ai-chat.context';

export function AiChatWindowInspirations({inspirations, cardsDecoration}: AiChatWindowInspirationsProps): ReactElement {
  const {state} = useAiChat();

  const isSmall = useIsSmallerThanBreakpointWidth(ScreenBreakpoints.LARGE);

  return (
    <div className={`${styles.container} ${isSmall ? styles.isSmall : ''}`}>
      <div className={`${styles.backgroundGradient} ${state.isSidebarExpanded ? styles.mellow : ''} ${isSmall ? styles.isSmall : ''}`} />
      <div className={`${styles.content} ${isSmall ? styles.isSmall : ''}`}>
        {cardsDecoration}
        <div className={styles.header}>
          <Text className={styles.headerText} size={TextSize.LARGE} bold val={window.i18next.t('pmwjs_ai_chat_see_what_you_can_create')} />
          <Icon icon="icon-sparkle-filled" type={IconType.GHOST_UNCOLORED} className={styles.headerSparkle} size={IconSize.SIZE_ICON_24} />
        </div>
        <div className={`${styles.inspirationsGrid} ${isSmall ? styles.isSmall : ''}`}>
          {inspirations.map((inspiration, index) => (
            <AiChatInspiration key={index} {...inspiration} />
          ))}
        </div>
      </div>
    </div>
  );
}
